import {ReactElement} from 'react';

import type {StateType, WhiskyBarType} from '../../types';
import {Link} from '@shopify/hydrogen';
import WhiskyBarSidebarPromoTile from './WhiskyBarSidebarPromoTile.client';
import ParsedBarContent from './ParsedBarContent.client';
import WidgetArea from '../WidgetArea.client';
import BarCarousel from '../carousels/BarCarousel.client';
import BarInfo from './BarInfo.client';
import MoreWhiskyBars from './MoreWhisky.client';

interface BarDetailsProps {
  whiskyBar: WhiskyBarType;
  states: ReadonlyArray<StateType>;
}

export default function BarDetails({
  whiskyBar,
  states,
}: BarDetailsProps): ReactElement {
  return (
    <main className="main">
      <BarInfo whiskyBar={whiskyBar} />
      <BarCarousel whiskyBar={whiskyBar} />
      <section>
        <div className="bars-page has-widget-area container">
          <div className="has-widget-area__l">
            <h6
              className="title-1"
              dangerouslySetInnerHTML={{__html: whiskyBar.summary}}
            ></h6>
            <ParsedBarContent whiskyBar={whiskyBar} />
            <div className="share-social-buttons mt-75">
              <span>Share this bar</span>
              <div
                role="button"
                tabIndex={-1}
                onClick={() => null}
                className="share-social-buttons__item"
              >
                <i className="icon-twitter"></i>
              </div>
              <div
                role="button"
                tabIndex={-1}
                onClick={() => null}
                className="share-social-buttons__item"
              >
                <i className="icon-whatsapp"></i>
              </div>
              <div
                role="button"
                tabIndex={-1}
                onClick={() => null}
                className="share-social-buttons__item"
              >
                <i className="icon-facebook"></i>
              </div>
              <div
                role="button"
                tabIndex={-1}
                onClick={() => null}
                className="share-social-buttons__item"
              >
                <i className="icon-email"></i>
              </div>
            </div>
          </div>
          <WidgetArea title="Explore offers &amp; events">
            <div className="widgets-mobile-sticky">
              {whiskyBar.sidebar_promotion !== null && (
                <WhiskyBarSidebarPromoTile
                  promoTile={whiskyBar.sidebar_promotion}
                />
              )}
              <div className="widget-section">
                <h4 className="title-2">Browse Whisky bars</h4>
                {states
                  .filter((state) => state.bar_count >= 1)
                  .map((state) => (
                    <Link
                      key={state.uuid}
                      to={`/bars/states/${state.slug}`}
                      className="button button_color_gray button_full button_type_link"
                    >
                      {state.name} Whisky Bars
                    </Link>
                  ))}
              </div>
            </div>
          </WidgetArea>
        </div>
      </section>
      <MoreWhiskyBars state={whiskyBar.state} />
    </main>
  );
}
